export default __webpack_public_path__ + "static/media/account-hover.c6e5e879.svg";